import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { Responsibles } from './repository';
import { Responsible } from './entity';
import { type ResponsibleData } from './dto';

export class ResponsiblesCommands
    implements Commands<Responsibles, Responsible, ResponsibleData>
{
    addAll(repo: Responsibles, data: ResponsibleData[]): Responsibles {
        data.forEach((responsibleData) => {
            this.add(repo, responsibleData);
        });
        return repo;
    }

    add(repo: Responsibles, data: ResponsibleData): Responsibles {
        const responsible = new Responsible({
            ...data,
        });
        repo.add(responsible);
        return repo;
    }

    update(repo: Responsibles, entity: Responsible): Responsible {
        repo.update(entity);
        return entity;
    }

    remove(repo: Responsibles, id: string): void {
        repo.remove(id);
    }

    create(repo: Responsibles, data: Omit<ResponsibleData, 'id'>): Responsible {
        const uuid = new UUID();
        const responsible = new Responsible({
            id: uuid.toString(),
            ...data,
        });
        repo.add(responsible);
        return responsible;
    }

    fromJSON(entity: Responsible[], changeCallback: () => void): Responsibles {
        const newResponsibles = new Responsibles(changeCallback);
        entity.forEach((responsible) => {
            newResponsibles.add(
                new Responsible({
                    ...responsible,
                }),
            );
        });
        return newResponsibles;
    }
}
